module.exports = __webpack_public_path__ + "static/intellect_fortress-52c5a27c19835748991418fb3408e9d1.png";